<template>
  <section id="search-results" class="card has-background-dark has-text-light">
    <header class="card-header">
      <p class="card-header-title has-text-light">
        {{ $t('search.result.title') }}
      </p><br>
      <small v-if="last">
        Updated at: {{ formatDate(last.date, 'DD.MM.YYYY') }}
      </small>
      <a href="#" class="card-header-icon has-text-light" @click="close">
        <b-tooltip
          :label="$t('search.result.close')"
          position="is-left"
          type="is-black">
          <b-icon icon="close" type=""></b-icon>
        </b-tooltip>
      </a>
    </header>
    <div class="card-content">
      <div class="content">
        <ul>
          <li v-for="i in columns" v-if="result[i]" :key="i">
            <label>{{ $t('search.result.columns.' + i)}}:</label>
            <span v-if="i === 'area'">{{ formatArea(result[i]) }}</span>
            <span v-if="i !== 'area'">{{ result[i] }}</span>
          </li>
          <li v-if="$conf.search[$store.getters['searchIndex']].showStatus && status">
            <label>{{ $t('search.result.field.status') }}:</label>
            <span :class="`tag is-rounded ${statusIcons[status.status]}`">&nbsp;</span>
            <span>{{ $t(status.status) }}</span>
          </li>
          <li v-if="$conf.search[$store.getters['searchIndex']].showEvents && events">
            <hr/>
            <label>{{ $t('search.result.field.events') }}:</label>
            <span>
              <div v-for="(evt, i) in events" :key="`evt-${i}`" class="event">
                {{ formatDate(evt['date']) }} {{ $t(evt['estimate']) }}
              </div>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <footer class="card-footer">
      <a href="#"
        v-if="$conf.chart.enabled"
        class="card-footer-item"
        :title="$t('chart')"
        @click="openChartModal">
        <span class="has-text-centered">
          <b-icon
            icon="chart-areaspline"
            size="is-large"
            type="is-light">
          </b-icon>
          <br/>
          {{ $t('view.chart') }}
        </span>
      </a>
      <a href="#"
        v-if="$conf.feedback.enabled"
        class="card-footer-item"
        :title="$t('feedback')"
        @click="openFeedbackModal">
        <span class="has-text-centered">
          <b-icon
            icon="alert"
            size="is-large"
            type="is-light">
          </b-icon>
          <br/>
          {{ $t('feedback') }}
        </span>
      </a>
    </footer>
  </section>
</template>

<script>

import ChartModalComponent from 'comp/chart/ChartModal'
import FeedbackModalComponent from 'comp/FeedbackModal'
import moment from 'moment'

export default {
  name: 'SearchResultsComponent',
  data () {
    return {
      columns: this.$conf.search[this.$store.getters['searchIndex']].properties || [],
      isChartModalActive: false,
      showWMS: false,
      statusIcons: {
        'not compliant': 'is-danger',
        'not sure': 'is-warning',
        'compliant': 'is-success'
      },
      actionQueue: []
    }
  },
  computed: {
    result () {
      return this.$store.getters['parcel']
    },
    status () {
      return this.$store.getters['parcelStatus']
    },
    events () {
      return this.$store.getters['parcelEvents']
    },
    last () {
      return this.$store.getters['parcelLastRow']
    }
  },
  mounted () {
    this.$store.dispatch(
      'loadParcelLastRow',
      this.result[this.$conf.search[this.$store.getters['searchIndex']].id]
    ).catch(err => {
      this.$conf.debug && console.error(err)
    })
    if (this.$conf.search[this.$store.getters['searchIndex']].showStatus) {
      this.$store.dispatch(
        'loadParcelStatus',
        this.result[this.$conf.search[this.$store.getters['searchIndex']].id]
      ).catch(err => {
        this.$conf.debug && console.error(err)
      })
    }
    if (this.$conf.search[this.$store.getters['searchIndex']].showEvents) {
      this.$store.dispatch(
        'loadParcelEvents',
        this.result[this.$conf.search[this.$store.getters['searchIndex']].id]
      )
        .then(result => {
          this.actionDelay()
        })
        .catch(err => {
          this.$conf.debug && console.error(err)
        })
    }
    if (this.$conf.search[this.$store.getters['searchIndex']].openChart) {
      this.openChartModal()
    }
  },
  methods: {
    formatArea (area) {
      return `${(Math.round(area * 100) / 100)} ha`
    },
    toDate (timestamp, format = 'DD.MM') {
      return moment.unix(timestamp).format(format)
    },
    formatDate (date, format = 'DD.MM') {
      return moment(date).format(format)
    },
    actionDelay () {
      this.actionQueue.forEach(action => {
        action()
      })
      this.actionQueue = []
    },
    openChartModal (e) {
      e && e.preventDefault()
      if (!this.result || !this.events) {
        this.actionQueue.push(this.openChartModal)
      } else {
        this.$buefy.modal.open({
          parent: this,
          width: 1200,
          component: ChartModalComponent,
          hasModalCard: true,
          canCancel: ['escape', 'outside'],
          props: {
            parcel: Object.assign({}, this.result, { events: this.events }),
            feedbackBtnClick: (e) => {
              this.openFeedbackModal(e)
            }
          }
        })
      }
    },
    openFeedbackModal (e) {
      e.preventDefault()
      if (!this.result || !this.events) {
        this.actionQueue.push(this.openFeedbackModal)
      } else {
        this.$buefy.modal.open({
          parent: this,
          component: FeedbackModalComponent,
          hasModalCard: true,
          canCancel: ['escape', 'outside'],
          props: {
            parcel: Object.assign({}, this.result, { events: this.events }),
            chartBtnClick: (e) => {
              this.openChartModal(e)
            }
          }
        })
      }
    },
    close () {
      if (this.$store.getters['searchResults'].length === 0) {
        this.$store.dispatch('clearSearch')
      } else {
        this.$store.dispatch('parcel', null)
      }
    }
  }
}

</script>

<style lang="stylus" scoped>
#search-results
  margin: 0px 6px 26px 6px
  header
    p
      padding-bottom: 1.2rem
    small
      position: absolute
      top: 2rem
      left: 0
  ul
    list-style-type: none
    margin: 0 0 1em 0
    label
      display: inline-block
      width: 130px
      text-align: right
      font-weight: bold
    .event
      display: inline-block
      padding-left: 135px
      color: rgb(255, 152, 0)
      &:first-child
        padding-left: 0
    hr
      background-color: rgba(255, 255, 255, .1)
      height: 1px
      margin: .5rem 2rem
  .tag
    display: inline-block
    width: 1.1rem
    height: 1.1rem
  a.card-footer-item
    transition: 0.3s
    color: white
    span.has-text-light
      transition: 0.3s
    &:hover
      color: rgb(255, 152, 0)!important
      span.has-text-light
        color: rgb(255, 152, 0)!important
</style>
